
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {
  computed, defineAsyncComponent, defineComponent, inject, PropType,
} from 'vue';
import { num2Cn } from '@/lib/index';
import { StuParseQuestionI } from '@/views/Teacher/addJob/question/js/interface';

export default defineComponent({
  components: {
    question: defineAsyncComponent(() => import('@/components/teacher/jobAnalysis/question/index.vue')),
  },
  props: {
    /** 模块标题 */
    moduleName: {
      type: String,
      require: true,
      default: '模块名',
    },
    /** 模块seq */
    seq: {
      type: Number,
      require: true,
    },
    /** 模块对应的题目list */
    questionList: {
      type: Array as PropType<StuParseQuestionI[]>,
      default: () => [],
    },
  },
  emits: ['reload'],
  setup(props, { emit }) {
    const title = computed(() => `${num2Cn(props.seq!)}、${props.moduleName}`);
    const jobView = inject('jobView');
    const reload = () => {
      emit('reload');
    };
    const qList = computed(() => props.questionList);
    return {
      title,
      jobView,
      qList,
      reload,
    };
  },
});
